import { Navigate, Outlet } from 'react-router'
import { useMe } from '@/auth/useMe'
import { PageNote } from '@/components/PageNote'

/**
 * Route guard for the archived fundraising module (spec-30): the /fundraising
 * routes only render while the backend reports `fundraising_enabled` on
 * GET /api/v1/me (the FUNDRAISING_UI_ENABLED setting). With the flag off
 * (default) every /fundraising path redirects to the landing page — no dead
 * ends, mirroring the RequireRole guard. UX only: the backend additionally
 * 404s the whole /api/v1/fundraising/* surface while the flag is off.
 */
export function RequireFundraisingEnabled() {
  const { me, loading } = useMe()

  if (loading) {
    return (
      <main className="flex min-h-svh items-center justify-center">
        <PageNote>Bezig met laden…</PageNote>
      </main>
    )
  }

  if (!me?.fundraising_enabled) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
